// extracted by mini-css-extract-plugin
export default {"title":"Main_title__3TI5d","buttons":"Main_buttons__06yGi","wrapper":"Main_wrapper__1H2jX","error":"Main_error__cisBm"};